// empty
import EmptyPage from "pages/empty";

// auth
import AuthLayout from "layouts/auth";
import ForgotPage from "pages/auth/forgot";
import LoginPage from "pages/auth/login";
import RegisterPage from "pages/auth/register";
import StatusPage from "pages/auth/status";
import VerifyPage from "pages/auth/verify";

// app
import DefaultLayout from "layouts/default";
import AboutPage from "pages/default/about";
import AroundPage from "pages/default/around";
import ContactPage from "pages/default/contact";
import FaqPage from "pages/default/faq";
import HomePage from "pages/default/home";
import JobPage from "pages/default/job";
import TermsPage from "pages/default/terms";
import JobsPage from "pages/default/jobs";
import SupportPage from "pages/default/support";

// panel
import PanelLayout from "layouts/panel";
import AccountPage from "pages/panel/account";
import BookmarksPage from "pages/panel/bookmarks";
import CreatePage from "pages/panel/create";
import MyJobsPage from "pages/panel/jobs";
import NotificationsPage from "pages/panel/notifications";
import PaymentPage from "pages/panel/payment";
import TransactionsPage from "pages/panel/transactions";
import WalletPage from "pages/panel/wallet";

// errors
import NotFoundPage from "pages/result/not-found";
import UnAuthorizedPage from "pages/result/un-authorized";

export default [
	// errors
	{
		path: "/403",
		name: "unauthorized",
		component: UnAuthorizedPage,
	},
	{
		path: "/404",
		name: "notfound",
		component: NotFoundPage,
	},
	// authorization
	{
		path: "/auth",
		name: "auth",
		component: AuthLayout,
		routes: [
			{
				path: "/auth",
				name: "statusRedirect",
				redirect: "/auth/status",
			},
			{
				path: "/auth/forgot",
				name: "forgot",
				component: ForgotPage,
			},
			{
				path: "/auth/login",
				name: "login",
				component: LoginPage,
			},
			{
				path: "/auth/register",
				name: "register",
				component: RegisterPage,
			},
			{
				path: "/auth/status",
				name: "status",
				component: StatusPage,
			},
			{
				path: "/auth/verify",
				name: "verify",
				component: VerifyPage,
			},
		],
	},
	{
		path: "/panel",
		name: "panel",
		component: PanelLayout,
		routes: [
			{
				name: "account",
				path: "/panel/account",
				component: AccountPage,
			},
			{
				name: "bookmarks",
				path: "/panel/bookmarks",
				component: BookmarksPage,
			},
			{
				name: "create",
				path: "/panel/create",
				component: CreatePage,
			},
			{
				name: "edit",
				path: "/panel/edit/:id",
				component: CreatePage,
			},
			{
				name: "jobs",
				path: "/panel/jobs",
				component: MyJobsPage,
			},
			{
				name: "notifications",
				path: "/panel/notifications",
				component: NotificationsPage,
			},
			{
				name: "paymentVerification",
				path: "/panel/payment-verification",
				component: PaymentPage,
			},

			// {
			// 	name: "transactions",
			// 	path: "/panel/transactions",
			// 	component: TransactionsPage,
			// },
			// {
			// 	name: "wallet",
			// 	path: "/panel/wallet",
			// 	component: WalletPage,
			// },
		],
	},
	// app
	{
		path: "/",
		name: "app",
		component: DefaultLayout,
		routes: [
			{
				name: "home",
				path: "/",
				component: HomePage,
			},
			{ name: "around", path: "/around", component: AroundPage },
			{
				name: "about",
				path: "/about",
				component: AboutPage,
			},
			{
				name: "around",
				path: "/around",
				component: EmptyPage,
			},
			{
				name: "contact",
				path: "/contact",
				component: ContactPage,
			},
			{
				name: "faq",
				path: "/faq",
				component: FaqPage,
			},
			{
				name: "jobs",
				path: "/jobs",
				component: JobsPage,
			},
			{
				name: "support",
				path: "/support",
				component: SupportPage,
			},
			{
				name: "terms",
				path: "/terms",
				component: TermsPage,
			},
			{
				name: "jobs",
				path: "/jobs",
				component: EmptyPage,
			},
			{
				name: "job",
				path: "/job/:id",
				component: JobPage,
			},
		],
	},
];
